module.exports = __webpack_public_path__ + "static/media/addFabric_button.405410da.png";